// import React, { useState, useEffect, useRef } from "react";
// import { useLocation } from "react-router-dom";

// const ScrollableCard = ({ children }) => {
//   const [showButton, setShowButton] = useState(true);
//   const cardRef = useRef(null);
//   const location = useLocation();

//   useEffect(() => {
//     const handleScroll = () => {
//       debugger;
//       if (cardRef.current) {
//         setShowButton(cardRef.current.scrollTop > 100);
//       }
//     };

//     if (cardRef.current) {
//       cardRef.current.addEventListener("scroll", handleScroll);
//     }

//     return () => {
//       debugger;
//       if (cardRef.current) {
//         debugger;
//         cardRef.current.removeEventListener("scroll", handleScroll);
//       }
//     };
//   }, []);

//   // Scroll to top when route changes
//   useEffect(() => {
//     if (cardRef.current) {
//       cardRef.current.scrollTo({ top: 0, behavior: "smooth" });
//     }
//   }, [location.pathname]);

//   const scrollToTop = () => {
//     window.scrollTo({
//       top: 0,
//       behavior: "smooth",
//     });
//   };

//   return (
// <div style={{ position: "relative", width: "100%", height: "100%" }}>
//   <div ref={cardRef} className="scrollCard">
//     {children}
//   </div>
//   {showButton && (
//     <button
//       className="scroll-to-top-btn"
//       onClick={scrollToTop}
//       title="Back to Top"
//     >
//       <i className="fa-regular fa-circle-up"></i>
//     </button>
//   )}
// </div>
//   );
// };

// export default ScrollableCard;

import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const ScrollableCard = ({ children }) => {
  const [showButton, setShowButton] = useState(false); // start hidden
  const cardRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      if (cardRef.current) {
        setShowButton(cardRef.current.scrollTop > 100);
      }
    };

    const card = cardRef.current;
    if (card) {
      card.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (card) {
        card.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  useEffect(() => {
    if (cardRef.current) {
      cardRef.current.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [location.pathname]);

  const scrollToTop = () => {
    if (cardRef.current) {
      cardRef.current.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  };

  return (
    <div
      style={{
        position: "absolute",
        height: "100%",
        width: "100%",
        overflow: "hidden",
      }}
    >
      <div
        ref={cardRef}
        className="scrollCard"
        style={{
          overflowY: "auto",
          overflowX: "hidden", //
          height: "100%",
          position: "relative",
        }}
      >
        {children}
      </div>

      {showButton && (
        <button
          className="scroll-to-top-btn"
          onClick={scrollToTop}
          title="Back to Top"
          style={{
            position: "absolute",
            bottom: "80px",
            right: "28px",
            zIndex: 1000,
            cursor: "pointer",
          }}
        >
          <i class="fa fa-arrow-circle-up" aria-hidden="true"></i>
        </button>
      )}
    </div>
  );
};

export default ScrollableCard;
